/**
 * Tag list component
 */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { PostStore } from '../../../stores/PostStore';
import { Post } from '../../../schemas/Post';
import { TagCollection, ShortTag } from '../../../schemas/Tag';
import { StreamStore } from '../../../stores/StreamStore';
import { CustomScrollBars } from '../../Stream/ScrollBar';

import * as Icon from 'react-fontawesome';

import './TagList.css';

interface TagListProps {
    active: number;
    onActionClick?: () => void;
}

/**
 * A tag list that can update the searchbox on a click or block a tag.
 * 
 * @export
 * @class TagList
 * @extends {(React.Component<TagListProps & { postStore?: PostStore; streamStore?: StreamStore }>)}
 */
@inject(allStores => ({
    postStore: allStores.postStore as PostStore,
    streamStore: allStores.streamStore as StreamStore,
}))
@observer
export class TagList extends React.Component<
    TagListProps & { postStore?: PostStore; streamStore?: StreamStore }
> {
    postStore = this.props.postStore!;

    generateList = (post: Post<TagCollection<ShortTag>>) => (
        <div className="TagList">
            <CustomScrollBars>
                {Object.keys(post.tags)
                    .filter(c => c !== '__typename' && Object.keys(post.tags[c]).length > 0)
                    .map(category => (
                        <div className="TagList-category-container" key={post.id + category}>
                            <div className="TagList-category-title backline">
                                <span className="Theme-background">{category}</span>
                            </div>
                            <ul className="TagList-category-list">
                                {Object.values(post.tags[category]).map(tag => (
                                    <li className="Taglist-category-list-element" key={tag.name}>

                                        <span 
                                            onClick={this.props.onActionClick} 
                                            className="Taglist-category-list-element-actions"
                                        >
                                            <span
                                                onClick={() => {
                                                    this.postStore.sendChips.add.push(tag.name);
                                                }}
                                            >
                                                <Icon name="plus-circle" />
                                            </span>

                                            <span
                                                onClick={() => {
                                                    this.postStore.searchQuery.currentInput = '';
                                                    this.postStore.searchQuery.chips = [tag.name];
                                                    this.postStore.sendChips.override = tag.name;
                                                }}
                                            >
                                                <Icon name="search" />
                                            </span>

                                            <span
                                                onClick={() => {
                                                    this.postStore.addBlacklistNode(tag.name);
                                                }}
                                            >
                                                <Icon name="ban" />
                                            </span>
                                        </span>
                                        <span className="Taglist-category-list-element-text">
                                            {tag.name}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
            </CustomScrollBars>
        </div>
    )

    render() {
        const hasPost = this.postStore.posts.length >= 1;
        const postList = hasPost ? (
            this.generateList(this.postStore.posts[this.props.active])
        ) : (
            <div className="TagList-empty-box">
                <span> Tags should be here, but alas, you need to search something. </span>
            </div>
        );

        return postList;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Info/TagList/TagList.tsx